import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import {
  gsap
} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import {
  NavInit
} from '../../../../includes/header-nav/header-nav';
// import {
//   closeNavigation,

// } from '../../../../includes/header-nav/nav-helpers';
import {
  imageryLoaded,
} from '../../utilities/helpers';
import {
  initBlocks
} from '../../modules/blocks/index';
import {
  initHome
} from './namespaces/page-home';
// import {
//   loadIntro,
// } from './barba-helpers';

function init() {
console.log("init barba");

  gsap.registerPlugin(ScrollToPlugin);

  //debugger
  // gsap.registerPlugin(GSDevTools) 
  let cleanupCurrentUI = null,
    body = document.querySelector('body'),
    root = document.querySelector(':root'),

    // gsap timeline declartion 
    tlBarba = gsap.timeline(),
    tlBarbaPause = true, // this will allow me to pause the timeline when needed
    spacerWidth,
    gridMargin, // gridMargin - any of the css grids (margins applied on the out container)
    scrollDuration = 1,
    EaseOption = "power4.inOut",
    Breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/['"]+/g, '').trim(); // Remove quotes and extra whitespace
  // GSDevTools.create({animation: tlBarba});

  barba.hooks.ready((data) => {
    // loading Intro
    // loadIntro(body, viewerBg);
    //initiate navigation 
    NavInit();
  }); //barba.hooks.beforeOnce((data) =>

  barba.init({
    // there are some fundamental issues with barba atm - a js error somewhere maybe?
    debug: true,
    timeout: 10000, // review (default is 2000)
    requestError: (trigger, action, url, response) => {
      console.log("requestError", response);
      // go to a custom 404 page if the user click on a link that return a 404 response status
      if (action === 'click' && response.status && response.status === 404) {
        barba.go('/404');
        console.log("404 barba error"); // reivew this and other 404 pages
      }
      //ensure we go to the next page if the click fails - this should really never happend though - review accordingly
      if (action === 'click') {
        // https://github.com/barbajs/barba/issues/475
        barba.force(barba.url.parse(url).path)
        /* stop script execution - https://stackoverflow.com/questions/9298839/is-it-possible-to-stop-javascript-execution */
        thisFunctionDoesNotExistInOrderToStopScriptExecution()
      }
      // prevent Barba from redirecting the user to the requested URL
      // this is equivalent to e.preventDefault() in this context
      return false;
    },
    transitions: [{
      name: 'default', // this new - complete review all events before. enter etc
      sync: false,
      beforeEnter(data) {
        console.log("beforeEnter default transition");
      },
      enter(data) {
        console.log("enter default transition");
      },
      afterEnter(data) {
        console.log("afterEnter default transition");
      },
    }],
    views: [{

        namespace: 'home',
        afterEnter(data) { // could be doing this earlier?! - review
        console.log("afterEnter: namespace = home");
          var container = data.next.container; //is the next page
          // cleanupCurrentUI = initHome(container); // review this - was deleted but i should kepe the clean up stuff?
          initHome(container);
        }
      },
      {
        namespace: 'page',
        afterEnter(data) {
          console.log("afterEnter: namespace = page");

        }
      }
    ]
  });

  // console.log("Global hooks", barba.hooks.beforeOnce);


  barba.hooks.beforeLeave((data) => {
    // console.log("GLOBAL -  beforeleave -- add loading class", data);
    body.classList.add("loading");
    body.classList.remove("loaded")

  }); //barba.hooks.beforeLeave((data) =>

  barba.hooks.afterEnter((data) => {
    console.log("GLOBAL - barba.hooks.after enter", data);
    const nextContainer = data.next.container;
    
     document.body.classList.remove("loading");
     document.body.classList.add("loaded"); // review this
    /// review all this
  // imageryLoaded(nextContainer); //review

    // const loaderinterval = setInterval(() => {
    //   // Check if body has the 'images-loaded' class
    //   if (document.body.classList.contains("images-loaded")) {
    //     document.body.classList.remove("loading");
    //     closeNavigation(nextContainer);

    //     setTimeout(() => {
    //       tlBarba.clear();
    //     }, 2000);

    //     clearInterval(loaderinterval);
    //   }
    // }, 10);
  }); //barba.hooks.afterEnter((data) =>

  barba.hooks.afterLeave((data) => {
    // console.log("GLOBAL -  afterleave");
    // this happens quite early - it means some of my transition work happens afte rthi?!
    // i.e transitions stuff starts at " beforeEnter", "enter" and afterEnter - but this is afterLeave - so it's not in sync with the other transitions


    let nextContainer = data.next.container, //is the next page
   
    updateDeviceClass,
    updateOrientationClass;

    if (data.next.url.path) {
      // Get all updated <li> elements from the new HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data.next.html;
      const updateItems = tempDiv.querySelectorAll('[data-barba-update] li');

      // Get all current <li> elements to update
      const currentItems = document.querySelectorAll('[data-barba-update] li');

      currentItems.forEach((item, index) => {
        if (updateItems[index]) {
          const newClasses = updateItems[index].classList.value;
          item.className = newClasses;
        }
      });
    }

    // TOUCH x MOUSE
    if (document.body.classList.contains("is-not-touch") == true) {
      updateDeviceClass = "is-not-touch";
    } else if (document.body.classList.contains("is-touch") == true) {
      updateDeviceClass = "is-touch";
    } else {
      updateDeviceClass = "";
    }
    // end chekc if existing touch class

    // ORIENTATION

    if (document.body.classList.contains("is-horizontal") == true) {
      updateOrientationClass = "is-horizontal";
      // console.log("updateOrientationClass",updateOrientationClass);

    } else if (document.body.classList.contains("is-vertical") == true) {
      updateOrientationClass = "is-vertical";
      // console.log("updateOrientationClass",updateOrientationClass);

    } else if (document.body.classList.contains("is-square") == true) {
      updateOrientationClass = "is-square";
      // console.log("updateOrientationClass",updateOrientationClass);
    }



    // Get body class from incoming page - native WP ones
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
      match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
      // If no body class, remove it
      document.body.setAttribute("class", "");
      // console.log("no body classes : removing them")

    } else {
      // Set the new body class
      document.body.setAttribute("class", match[1]);
      // console.log("new body classes added");
    }
    // additional svs js framework classes etc
    document.body.classList.add(updateDeviceClass); // apply touch or not class
    document.body.classList.add(updateOrientationClass); // apply is-horizontal, is-vertical or is-square class


  }); //barba.hooks.afterLeave((data) =>

}

export default init